import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { shortTitleSelector } from 'selectors/indicator';
import { timeframeLatest } from 'selectors/indicator/timeframe';

// Components
import UsSnapshotMap from 'components/usSnapshotMap';
import WorldSnapshotMap from 'components/worldSnapshotMap';
import IndicatorHeader from 'components/indicatorHeader';

// Styles
import styles from './snapshotView.scss';

const SnapshotView = ({
  match: { params: { category } },
  activeTimeframe: { label },
  shortTitle,
}) => (
  <div>
    <IndicatorHeader showNarrative />
    <section className={styles.snapshotMap}>
      <h2 className={styles.title}>
        {'usdata' === category ?
          (<div>{shortTitle} ({label})</div>) :
          (<div>{shortTitle}</div>)
        }
      </h2>
      {'international' === category ?
        (<WorldSnapshotMap />) :
        (<UsSnapshotMap />)}
    </section>
  </div>
);

SnapshotView.defaultProps = {
  activeTimeframe: {},
};

SnapshotView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string.isRequired,
      indicatorName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  activeTimeframe: PropTypes.shape({
    label: PropTypes.string,
  }),
  shortTitle: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  activeTimeframe: timeframeLatest(state),
  shortTitle: shortTitleSelector(state),
});

export default withRouter(connect(mapStateToProps)(SnapshotView));



// WEBPACK FOOTER //
// ./app/components/snapshotView/index.js